import { REQUEST_METHOD } from '../../middlewares/services';

import * as types from './types';
import { endpoint } from '../../../config/const';

const list = (data) => ({
    type: types.LIST_STORE,
    meta: {
        endpoint: endpoint.LIST_STORE,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const upgradeLadiboost = (data) => ({
    type: types.ACTIVE_LADIBOOST,
    meta: {
        endpoint: endpoint.ACTIVE_LADIBOOST,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const upgrade = (data) => ({
    type: types.UPGRADE_STORE,
    meta: {
        endpoint: endpoint.UPGRADE_STORE,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const upgradeList = (data) => ({
    type: types.UPGRADE_STORE_LIST,
    meta: {
        endpoint: endpoint.UPGRADE_STORE_LIST,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const downgrade = (data) => ({
    type: types.DOWNGRADE_STORE,
    meta: {
        endpoint: endpoint.DOWNGRADE_STORE,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});


const listPackages = (data) => ({
    type: types.LIST_PACKAGE,
    meta: {
        endpoint: endpoint.LIST_PACKAGE,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const getListCourse = (data) => ({
    type: types.LIST_PACKAGE_COURSE,
    meta: {
        endpoint: endpoint.LIST_PACKAGE_COURSE,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});


const listDeals = (data) => ({
    type: types.LIST_DEALS,
    meta: {
        endpoint: endpoint.LIST_DEALS,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});


const infoLadiboost = (data) => ({
    type: types.INFO_LADIBOOST,
    meta: {
        endpoint: endpoint.INFO_LADIBOOST,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const listPackagesLadiboost = () => ({
    type: types.LIST_PACKAGE_LADIBOOST,
    meta: {
        endpoint: endpoint.LIST_PACKAGE_LADIBOOST,
        method: REQUEST_METHOD.POST,
        body: {},
        hasAuth: true,
    }
});

const clearToken = (data) => ({
    type: types.CLEAR_TOKEN,
    meta: {
        endpoint: endpoint.CLEAR_TOKEN,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const getUserinfo = (data) => ({
    type: types.GET_USERINFO,
    meta: {
        endpoint: endpoint.GET_USERINFO,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const activeStore = (data) => ({
    type: types.ACTIVE_STORE,
    meta: {
        endpoint: endpoint.ACTIVE_STORE,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const changePackageStore = (data) => ({
    type: types.CHANGE_PACKAGE_STORE,
    meta: {
        endpoint: endpoint.CHANGE_PACKAGE_STORE,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const getAddonsList = (data) => ({
    type: types.GET_ADDON_LIST,
    meta: {
        endpoint: endpoint.GET_ADDON_LIST,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const getResourceLimitConfig = () => ({
    type: types.GET_RESOURCE_LIMIT_CONFIG,
    meta: {
        endpoint: endpoint.GET_RESOURCE_LIMIT_CONFIG,
        method: REQUEST_METHOD.POST,
        body: {},
        hasAuth: true,
    }
});

const addResourceLimit = (data) => ({
    type: types.ADD_RESOURCE_LIMIT,
    meta: {
        endpoint: endpoint.ADD_RESOURCE_LIMIT,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const updateResourceLimit = (data) => ({
    type: types.UPDATE_RESOURCE_LIMIT,
    meta: {
        endpoint: endpoint.UPDATE_RESOURCE_LIMIT,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const deleteResourceLimit = (data) => ({
    type: types.DELETE_RESOURCE_LIMIT,
    meta: {
        endpoint: endpoint.DELETE_RESOURCE_LIMIT,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});
const listStaffs = (body) => ({
    type: types.LIST_STAFFS,
    meta: {
        endpoint: endpoint.LIST_STAFFS,
        method: REQUEST_METHOD.POST,
        body,
        hasAuth: true
    }
});
const renewDemo = (body) => ({
    type: types.RENEW_DEMO,
    meta: {
        endpoint: endpoint.RENEW_DEMO,
        method: REQUEST_METHOD.POST,
        body,
        hasAuth: true
    }
});
const cancelTrial = (body) => ({
    type: types.CANCEL_TRIAL,
    meta: {
        endpoint: endpoint.CANCEL_TRIAL,
        method: REQUEST_METHOD.POST,
        body,
        hasAuth: true
    }
});
const createTrial = (body) => ({
    type: types.CREATE_TRIAL,
    meta: {
        endpoint: endpoint.CREATE_TRIAL,
        method: REQUEST_METHOD.POST,
        body,
        hasAuth: true
    }
});
const buyResource = (body) => ({
    type: types.BUY_RESOURCE,
    meta: {
        endpoint: endpoint.BUY_RESOURCE,
        method: REQUEST_METHOD.POST,
        body,
        hasAuth: true
    }
});
export default {
    list,
    upgrade,
    upgradeLadiboost,
    infoLadiboost,
    upgradeList,
    downgrade,
    activeStore,
    getListCourse,
    listPackages,
    listDeals,
    clearToken,
    getUserinfo,
    changePackageStore,
    listPackagesLadiboost,
    getAddonsList,
    getResourceLimitConfig,
    addResourceLimit,
    updateResourceLimit,
    deleteResourceLimit,
    listStaffs,
    renewDemo,
    cancelTrial,
    createTrial,
    buyResource
}